module.exports = __webpack_public_path__ + "img/iconCircleArrow.8655e5b5.png";